import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';
import Layout from '../layout';
// import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const MechaInfoModal = ({ store, onClose, locales }) => {
  store.use();

  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <Layout className={cx(styles.mechaInfoModalRoot)} isOpen={store.isOpen} onClose={store.onClickClose}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.logo} />
          <div className={styles.title}>{locales.mechaOverview}</div>
        </div>
        <div className={styles.detail}>
          <div className={styles.avatar}>
            <div className={styles.avatarInner} style={{ backgroundImage: `url(${store.mechaInfo?.modalAvatar})` }} />
          </div>
          <div className={styles.wrap}>
            <div className={styles.type}>{store.mechaInfo?.type}</div>
            <div className={styles.mechaName}>{store.mechaInfo?.name}</div>
          </div>
          <div className={styles.attrs}>
            <div className={styles.line}>
              {store.mechaInfo?.modalAttrs.slice(0, 2).map((item, index) => {
                return (
                  <div className={cx(styles.attrItem)} key={index}>
                    <span className={styles.name}>{`[ ${item.name} ]`}</span>
                    <span className={styles.value}>{`${item.value}`}</span>
                  </div>
                );
              })}
            </div>
            <div className={styles.line}>
              {store.mechaInfo?.modalAttrs.slice(2, 4).map((item, index) => {
                return (
                  <div className={cx(styles.attrItem)} key={index}>
                    <span className={styles.name}>{`[ ${item.name} ]`}</span>
                    <span className={styles.value}>{`${item.value}`}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.number}>
            {store.mechaInfo?.id === 'kangsitanding' ? locales.shipType : locales.modelNumber}：{store.mechaInfo?.number}
          </div>
        </div>
        <div className={styles.background}>
          <h3>
            {'['}
            {locales.background}
            {']'}
          </h3>
          <div className={styles.para}>{store.mechaInfo?.background}</div>
        </div>
        <div className={styles.armedMessage}>
          <h3>
            {'['}
            {locales.weaponry}
            {']'}
          </h3>
          <div className={styles.para}>
            {store.mechaInfo?.armedMessage.map((item, index) => {
              return <p key={index}>{`${item}`}</p>;
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default wrapStore(MechaInfoModal, Store);
